import axios from "axios";
import Auction from "./Auction";
import Error404 from "./Error404";
import React ,{Component} from "react";
import {Container, Row} from "react-bootstrap";
import {Loading} from "./partials/Global/Loading";
import Pagination from "./partials/Global/Pagination";
import {CopyRight} from "./partials/Global/CopyRight";
import {Navigation} from "./partials/Global/Navigation";
import {FooterBody} from "./partials/Global/FooterBody";
import {DottedLoading} from "./partials/Global/DottedLoading";
import {ProgressScrollButton} from "./partials/Global/ProgressScrollButton";

class Auctions extends Component {
    auctionCode = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            status: this.props.match.params.status,
            auctions: {},
            filters: {},
            paginate: [],
            isLoading: true,
        };

        // Set current page from url or 1
        const query = new URLSearchParams(this.props.location.search);
        this.state.paginate.currentPage = query.get("page") || 1;
    };

    setFilters = (event) => {
        event.preventDefault();
        const filters = {
            Auctions: {
                LIKE: {
                    code: this.auctionCode.current.value,
                }
            }
        };
        const paginate = {...this.state.paginate};
        // Reset to page 1
        paginate.currentPage = 1;
        this.setState({paginate, filters});
    };

    handleStatusChange = (event) =>  {
        let status = event.target.getAttribute("data-value");
        const paginate = {...this.state.paginate};

        // Reset to page 1
        paginate.currentPage = 1;

        this.setState({
            paginate: paginate,
            status: status
        });

        this.props.history.push(status);
    };

    async componentDidMount() {
        await this.getAuctions();
    }

    async componentDidUpdate(prevProps, prevState) {
        const query = new URLSearchParams(this.props.history.location.search);

        if (prevState.status !== this.state.status || prevState.filters !== this.state.filters) {
            await this.getAuctions();
        }

        if (this.state.paginate.currentPage !== prevState.paginate.currentPage) {
            query.set("page", this.state.paginate.currentPage);
            this.props.history.push(
                decodeURIComponent(this.props.location.pathname) +
                "?" +
                decodeURIComponent(query.toString())
            );

            await this.getAuctions();
        }
    }

    getAuctions = async () => {
        this.setState({isLoading: true});
        const result = await axios
            .post(
                process.env.REACT_APP_API_URL +
                process.env.REACT_APP_GET_AUCTIONS_PATH +
                this.state.paginate.currentPage +
                "/10.json",
                {
                    apiKey: process.env.REACT_APP_API_PUBLIC_TOKEN,
                    status: this.state.status,
                    filters: this.state.filters,
                }
            );

        let auctions = result.data.result.data.auctions;

        this.setState({
            auctions: auctions,
            paginate: result.data.result.data.paginate,
            isLoading: false
        });

        return result;
    };

    updatePaginate = currentPage => {
        const paginate = {...this.state.paginate};
        paginate.currentPage = currentPage;
        this.setState({paginate});
    };

    render() {
        if (!['active', 'archive', 'all'].includes(this.state.status)) return <Error404 />
        return (
            <>
                <Loading/>
                <ProgressScrollButton/>
                <Navigation/>
                <main>
                    <header className="work-header">
                        <Container className="mt-80">
                            <Row>
                                <div className="col-12">
                                    <div className="caption">
                                        <div className="sub-title">
                                            <a href={"/"}><span>خانه</span></a>
                                            <span>&nbsp; / &nbsp;</span>
                                            <span>مزایده و فروش املاک</span>
                                        </div>
                                        <h1>مزایده‌های املاک</h1>
                                    </div>
                                </div>
                            </Row>
                        </Container>
                    </header>
                    <section className="portfolio pt-70 pb-0">
                        <div className="container-xxl">
                            <Row>
                                <div className="filtering col-12 mb-60 text-center">
                                    <div className="filter">
                                        <span className="text">فیلتر با :</span>
                                        <span onClick={this.handleStatusChange}
                                              data-value='all'
                                              className={this.state.status === 'all'? 'active' : ''}>
                                            همه
                                        </span>
                                        <span onClick={this.handleStatusChange}
                                              data-value='active'
                                              className={this.state.status === 'active'? 'active' : ''}>
                                            جاری
                                        </span>
                                        <span onClick={this.handleStatusChange}
                                              data-value='archive'
                                              className={this.state.status === 'archive'? 'active' : ''}>
                                            پیشین
                                        </span>
                                    </div>

                                    <div className="mini-search md-mb80">
                                        <div className="item search mb-40">
                                            <form onSubmit={this.setFilters}>
                                                <div className="form-group">
                                                    <input type="text" name="shop_search" placeholder="شماره مزایده" ref={this.auctionCode}/>
                                                    <button type="submit">
                                                        <span className="pe-7s-search"> </span>
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </Row>
                            {!this.state.isLoading
                                ? (this.state.auctions.length >= 1
                                    ? <div className="gallery padding-rl-20">
                                        <Row className="grid max-margin">
                                            {Object.keys(this.state.auctions).map(key => (
                                                <Auction key={key} data={this.state.auctions[key]} />
                                            ))}
                                        </Row>
                                      </div>
                                    : <div className='mt-30 mb-80 text-center'><span>موردی جهت نمایش یافت نشد.</span></div>)
                               : <div className='mt-30 mb-80 text-center' style={{marginRight: '49%'}}><DottedLoading/></div>}
                        </div>
                    </section>
                    {!this.state.isLoading && this.state.auctions.length >= 1 &&
                    <section className="main-shop pt-0 pb-70">
                        <div className="container">
                            <div className="row md-marg">
                                <div className="col-lg-12">
                                    <div className={"shop-products"}>
                                        <Row>
                                            <div className="pagination d-flex justify-content-center mt-30">
                                                <Pagination
                                                    paginate={this.state.paginate}
                                                    updatePaginate={this.updatePaginate}
                                                />
                                            </div>
                                        </Row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>}
                </main>
                <footer className="pt-80 sub-bg">
                    <FooterBody/>
                    <CopyRight/>
                </footer>
            </>
        );
    }
}

export default Auctions;
